import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';

import { Tooltip } from '@salesforce/design-system-react';

import './SelectionProfileAttributes.scss';

class SelectionProfileAttributes extends Component {
  render() {
    const { formatMessage } = this.props.intl;
    const { tags } = this.props.profile;

    const tooltipContent = formatMessage({
      id: 'components.ecs.selectionBrowser.profile.tooltip'
    });
    return (
      <div className="profile-attributes-pane">
        <h1>
          <span>
            <FormattedMessage id="components.ecs.selectionBrowser.profile.header" />
            <Tooltip
              position="overflowBoundaryElement"
              align="right"
              content={tooltipContent}
              variant="learnMore"
            />
          </span>
        </h1>
        <ul>
          {(tags || []).map((tag, idx) => (
            <li
              key={`selection-attribute-tag-${idx}`}
              className="profile-attribute-tag"
            >
              <span className="truncate" title={tag.tagType}>
                {tag.tagType}
              </span>
              <span className="truncate" title={tag.tagValue}>
                {tag.tagValue}
              </span>
            </li>
          ))}
        </ul>
      </div>
    );
  }
}

SelectionProfileAttributes.contextTypes = {
  router: PropTypes.object
};

SelectionProfileAttributes.propTypes = {
  actions: PropTypes.object,
  profile: PropTypes.shape({
    tags: PropTypes.arrayOf(
      PropTypes.shape({
        tagType: PropTypes.string,
        tagValue: PropTypes.string
      })
    )
  }),
  location: PropTypes.object
};

export default injectIntl(SelectionProfileAttributes);
